import { ConfigContext } from './ConfigContext';
import { PLATFORM_FEE_PERCENT, TAX_PERCENT } from '../../config';

export default function ConfigProvider({ children }) {
  // Directly provide the centralized constants from config.js
  const fees = {
    PLATFORM_FEE_PERCENT,
    TAX_PERCENT,
  };

  return (
    <ConfigContext.Provider value={{ fees, isConfigLoading: false }}>
      {children}
    </ConfigContext.Provider>
  );
}
